package sarka.design.skoria.network

import io.ktor.client.HttpClient

/**
 * Only the client engine genuinely differs per platform (OkHttp / CIO / JS),
 * so that's all we declare as expect/actual. URLs are resolved in common code
 * from [ServerConfig] so the platforms cannot disagree.
 */
expect fun createPlatformHttpClient(): HttpClient

fun defaultApiUrl(): String = ServerConfig.active.apiUrl

fun defaultWsUrl(): String = ServerConfig.active.wsUrl

fun defaultDmUrl(): String = ServerConfig.active.dmUrl
